export const CLEAN_TENDER = 'clean_tender';
export const SET_TENDER = 'set_tender';
export const SET_TENDER_LIST = 'set_tender_list';
export const SYNC_FAILED = 'update_sync_error';
export const SYNC_FINISHED = 'tender_sync_has_finished';
export const SYNC_INITIATED = 'tender_sync_was_initiated';
export const SAVE_INITIATED = 'tender_save_was_initiated';
export const TENDER_SET_SAVED = 'tender_set_saved';
